import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import { gray5, primary } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';
import NvTextArea from 'shared/components/inputs/nv-text-area';
import NvTooltip from 'shared/components/nv-tooltip';
import { useFormContext } from 'react-hook-form';

const styles = css`
  .add-more {
    width: max-content;
  }
  .objective-textarea-container {
    min-height: 45px;
    border-radius: ${quarterSpacing}px;
    box-shadow: 0 0 0 1px ${gray5};
    width: 100%;
    .trash-container {
      visibility: hidden;
    }
    &:focus-within {
      box-shadow: 0 0 0 1px ${primary};
    }
    &:hover, &:focus-within {
      .trash-container {
        visibility: visible;
      }
    }
    .objective-textarea {
      min-height: 100%;
      width: 90%;
      .nv-text-area {
        height: 100%;
        display: flex;
        align-items: center;
        textarea {
          border: none;
          box-shadow: none;
          min-height: 100%;
          background-color: transparent;
        }
        .bs4-input-group-text {
          align-items: flex-start;
          background: transparent;
          border: none;
          padding-right: ${quarterSpacing}px;
        }
      }
    }
  }
`;
const ObjectiveInputList = (props) => {
  const {
    name,
    fields,
    handleAddField,
    handleRemoveField,
    handleBlurField,
    isAddingField,
  } = props;

  const { formState: { errors } } = useFormContext();
  const handleAddAIObjective = () => {
    handleAddField();
  };

  const handleRemoveObjective = (id) => {
    handleRemoveField(id);
  };

  const getMaximumfieldCount = () => {
    if (name === 'aiCharacterObjections') {
      return 5;
    }
    return 4;
  };

  const showDeleteicon = (index) => {
    if (name === 'aiCharacterObjections' && index === 0) {
      return false;
    }
    return true;
  };

  const isAddMoreDisabled = fields.length >= getMaximumfieldCount() || isAddingField;

  return (
    <div css={styles}>
      {fields && fields.map((objective, index) => (
        <div className='d-flex objective-textarea-container align-items-center mt-2' key={objective.id}>
          <NvTextArea
            name={`${name}[${index}].text`}
            withForm
            key={objective.id}
            className='objective-textarea bg-white ml-1 align-items-center'
            textareaClassName='text-large-body lh-25'
            onBlur={(e) => {
              const fieldError = errors?.[name]?.[index];
              handleBlurField(objective.id, e.target.value, fieldError);
            }}
          />
          { showDeleteicon(index)
          && (
            <ClickableContainer
              className='ml-auto pr-3 trash-container'
              onClick={() => {
                handleRemoveObjective(objective.id);
              }}
            >
              <NvIcon
                icon='trash'
                size='small'
                className='text-primary'
              />
            </ClickableContainer>
          )}
        </div>
      ))}
      <ClickableContainer
        className='add-more'
        disabled={isAddMoreDisabled}
        onClick={handleAddAIObjective}
      >
        <NvTooltip
          text={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.DISABLED_ADD_MORE_TOOLTIP(5)}
          enabled={isAddMoreDisabled}
        >
          <div className={`d-flex mt-2 ${isAddMoreDisabled ? 'text-gray-4' : 'text-primary'}`}>
            <NvIcon size='small' icon='add' />
            <p
              className='mb-0 ml-2'
            >
              {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.ADD_MORE()}
            </p>
          </div>
        </NvTooltip>
      </ClickableContainer>
    </div>
  );
};

export default ObjectiveInputList;
